import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Form, Formik } from 'formik';
import Yup from '../../utils/yup';
import simpletaskService from '../../service/simpletask.service';
import masterDataService from '../../service/masterData.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';

import useMenus from '../../context/MenuContext';
import { useLoader } from '../../provider/LoaderProvider';
import FormFields from './FormFields';
import { FormButtonPanelUI } from '../Interface';
import FormTabs from './FormTabs';
import { generateAutocompleteItems } from '../../utils/helper';
import { TaskReportOptions } from '../../config/taskReport';
import useUsers from '../../context/UsersContext';

export const TaskReportForm = ({ selectedTask, setShowDialog, onReportAdd }) => {
  const { menus, getMenus, getMenuSubMenuId } = useMenus();
  const { getUser, user } = useUsers();
  const { showLoader, hideLoader } = useLoader();
  const [submenu, setSubmenu] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [autocompleteData, setAutocompleteData] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [initValues, setInitValues] = useState({});
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    type: [],
  });

  const def = {
    simpleTaskId: null,
    timeSpent: '',
    me: '',
    typeId: null,
    description: '',
    createdBy: user.userId,
  };

  useEffect(() => {
    getMenus();
    if (!Object.keys(user).length) getUser();
    setDefaultValues(def);
  }, []);

  useEffect(() => {
    setSubmenu(getMenuSubMenuId('simpleTask'));
  }, [menus]);

  useEffect(() => {
    if (submenu) initDefaultValues();
  }, [submenu]);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          typeId: autocompleteData?.type?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          type: autocompleteData?.type?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  const initDefaultValues = () => {
    masterDataService
      .typeToForm(submenu)
      .then((data) => {
        const aData = {
          type: data,
        };
        setAutocompleteData(aData);

        const acOptions = {
          type: generateAutocompleteItems(aData.type.typeItems, 'itemName', 'itemId'),
        };
        setAutoCompleteOptions(acOptions);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!_.isEqual(defaultSelectedValues, selectedTask)) {
        valuesToForm();
      } else {
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  const validationSchema = Yup.object().shape({
    simpleTaskId: Yup.string().required(),
    timeSpent: Yup.number().required().positive(),
    me: Yup.string(),
    typeId: Yup.string().required(),
    description: Yup.string().max(500),
  });

  const valuesToForm = () => {
    if (selectedTask) {
      const { simpleTaskId, timeSpent, me, typeId, description } = selectedTask;

      setInitValues({
        simpleTaskId,
        timeSpent,
        me: TaskReportOptions[0].value,
        createdBy: user.userId,
        typeId: typeId ?? selectedTask.simpleTaskTypeId,
        description,
      });
    } else {
      setInitValues(defaultValues);
    }
  };

  const handleInsertObject = (values, { resetForm }) => {
    showLoader();
    simpletaskService
      .createTaskReport(values)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        resetForm();
        if (selectedTask && onReportAdd) {
          setShowDialog(false);
          onReportAdd(data);
        }
      })
      .finally(() => {
        hideLoader();
      });
  };

  return (
    <div className={selectedTask ? '' : 'bg-gray-100 h-full w-full pt-32 fixed top-0 left-0'}>
      <div className={selectedTask ? 'mt-5' : 'h-auto bg-white py-5 px-5 w-96  mx-auto rounded-lg'}>
        <Formik
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleInsertObject}
          enableReinitialize
        >
          {({ values, setFieldValue, errors, validateField }) => (
            <Form>
              <FormFields
                selectedTask={selectedTask}
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                validateField={validateField}
                autocompleteOptions={autocompleteOptions}
                user={user}
              />

              <FormTabs values={values} errors={errors} formId={'description'} value={initValues.description} />

              <FormButtonPanelUI />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
